import { render, staticRenderFns } from "./readonly-input.vue?vue&type=template&id=19a93e2e"
import script from "./readonly-input.vue?vue&type=script&lang=js"
export * from "./readonly-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports